import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import { getRunningCampaigns, selectCampaignsWithUndeliveredMessages } from '@common/reducers/CampaignSelectors';
//import CampaignInformation from './campaign-information'
import RowStack from '@common/components/common/row-stack/RowStack';
import { campaignsSelectOneObjectByQuery } from '@common-reducers/DBServiceThunks';
import { useOpenCampaignPage } from '@common-views/campaigns-redesign/open-campaign-page';
import { taskActions } from '@common/reducers/TasksReducer';
import CampaignActionsMenu from './campaign-actions-menu';
import InProgressCampaignIndicator from './in-progress-campaign-indicator';
import InProgressCampaignsStuckMessagesIndicator from './in-progress-campaigns-stuck-messages-indicator';

export default function InProgressCampaignsIndicatorDialog() {
    console.log("inProgressCampaignIndicatorDialog rendered");
    const dispatch = useAppDispatch()

    const inProgressCampaigns = useAppSelector(state => getRunningCampaigns(state))
    
    // Filter campaigns to only show those that haven't fully delivered yet
    const campaignsWithUndeliveredMessages = useAppSelector(selectCampaignsWithUndeliveredMessages);

    // The pill's campaign document — a step of a sequence opens the SEQUENCE.
    const pillCampaign = useAppSelector(state => {
        const id = campaignsWithUndeliveredMessages[0]?._id;
        return id ? campaignsSelectOneObjectByQuery(state.DBCampaignReducer, { _id: id }) : undefined;
    }) as { _id?: string; dripId?: string } | undefined;
    const openCampaignPage = useOpenCampaignPage();

    const openCampaignDetail = () => {
        const campaignId = campaignsWithUndeliveredMessages[0]?._id;
        if (!campaignId) return;
        dispatch(taskActions.setIsTasksPanelOpen(false));
        // The redesign overlay is ROUTE-driven. Through the shared launcher: it
        // OPENS the overlay before routing it (FE#318 — this used to navigate
        // first, so a router throw left the pill doing nothing) and closes the
        // planner overlay, which would otherwise sit on top of the page.
        openCampaignPage(pillCampaign?.dripId ? String(pillCampaign.dripId) : String(campaignId));
    }

    return (
        <>
            {campaignsWithUndeliveredMessages?.length > 0 &&
                <>
                    <RowStack gap={1}>
                        {/* {<CampaignInformation
                            showSentProgress={false}
                            width='400px'
                            campaignId={campaignsWithUndeliveredMessages[0]._id}
                        />} */}

                        <InProgressCampaignIndicator
                            key={campaignsWithUndeliveredMessages[0]._id}
                            campaignId={campaignsWithUndeliveredMessages[0]?._id ?? ''}
                            onClick={openCampaignDetail}
                        />

                        <InProgressCampaignsStuckMessagesIndicator campaignId={campaignsWithUndeliveredMessages[0]?._id ?? ''} />

                        <CampaignActionsMenu
                            campaignId={campaignsWithUndeliveredMessages[0]?._id ?? ''}
                            shouldShowViewLogs={false}
                        />
                    </RowStack>


                    {/* {campaignToDisplay?.length > 1 && totalProgress.totalContacts > 0 &&
                        <RowStack>
                            <inProgressCampaignIndicator
                                key={totalProgress.campaignId}
                                isAllCampaigns={true}
                                campaignId={totalProgress.campaignId}
                                numberOfContacts={totalProgress.totalContacts}
                                numberOfSentMessages={totalProgress.totalSentMessages}
                                showProgressBar={true} />

                            <IconButton onClick={openAllCampaignsProgress}><KeyboardArrowDown /></IconButton>
                            <Menu
                                open={isAllCampaignsProgressOpen}
                                anchorEl={allCampaignsProgressAnchorEl}
                                onClose={closeAllCampaignsProgress}
                                PaperProps={{
                                    style: {
                                        padding: '7px 10px 2px 10px',
                                    }
                                }}
                            >
                                {campaignToDisplay.map((campaign, index) => (
                                    <Tooltip key={`${campaign._id}_tooltip_${index}`} placement='left' arrow
                                        componentsProps={{
                                            tooltip: {
                                                sx: {
                                                    backgroundColor: 'var(--color-surface)',
                                                },
                                            },
                                            arrow: {
                                                sx: {
                                                    color: 'var(--color-surface)',
                                                },
                                            },
                                        }}
                                        title={
                                            <div key={`${campaign._id}_tooltip_component`} style={{ maxWidth: '450px', maxHeight: '120px', overflow: 'auto', }}>
                                                <CampaignInformation
                                                    showSentProgress={false}
                                                    width='400px'
                                                    campaignId={campaign.campaignId} />
                                            </div>
                                        }>
                                        <div key={`${campaign._id}_indicator`} style={{ marginBottom: '5px', }}>
                                            <inProgressCampaignIndicator
                                                onClick={closeAllCampaignsProgress}
                                                campaignId={campaign.campaignId}
                                                numberOfContacts={campaign.numberOfContacts}
                                                numberOfSentMessages={numberOfSentMessagesByCampaignId[campaignToDisplay[index].campaignId]} />
                                        </div>
                                    </Tooltip>
                                ))}
                            </Menu>
                        </RowStack>
                    } */}
                </>
            }
        </>
    )
}